import React, { Component } from "react";
import { Container } from "react-bootstrap";

class Footer extends Component {
  render() {
    return (
      <footer>
        <Container>
          <hr />
          <p className="text-center">
            &copy; 2020 <b>btw ta strona jest w fazie budowy</b>
          </p>
        </Container>
      </footer>
    );
  }
}

export default Footer;
